import './index.css';

const OE = () => {
    return ( 
        <section className="ourexpertise" id='ourexpertise'>
            <h2>Our <span> Expertise </span></h2>
            <div className="head1">
                <div className="expertise1">
                    <img src="images/building.png" alt="" />
                    <h1>Building Construction
                        <p>
                       Hellno World sit amet consectetur adipisicing elit. Dolores mollitia ipsa ab, corporis atque accusantium iste hic, natus voluptas exercitationem sapiente cumque architecto repudiandae laudantium molestias omnis maxime, velit itaque?
                        </p>
                        <button>KNOW MORE</button>
                    </h1>
                </div>
                <div className="expertise2">
                    <img src="images/hydro-power.png" alt="" />
                    <h1>Hydro Power
                        <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolores mollitia ipsa ab, corporis atque accusantium iste hic, natus voluptas exercitationem sapiente cumque architecto repudiandae laudantium molestias omnis maxime, velit itaque?
                        </p>
                        <button>KNOW MORE</button>
                    </h1>
                </div>
            </div>

            <div className="head2">
                <div className="expertise3">
                    <img src="images/irrigation.png" alt="" />
                    <h1>Irrigation  
                        <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolores mollitia ipsa ab, corporis atque accusantium iste hic, natus voluptas exercitationem sapiente cumque architecto repudiandae laudantium molestias omnis maxime, velit itaque?
                        </p>
                        <button>KNOW MORE</button>
                    </h1>
                </div>

                <div className="expertise4">
                    <img src="images/roads.png" alt="" />
                    <h1>Roads
                        <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolores mollitia ipsa ab, corporis atque accusantium iste hic, natus voluptas exercitationem sapiente cumque architecto repudiandae laudantium molestias omnis maxime, velit itaque?
                        </p>
                        <button>KNOW MORE</button>
                    </h1>
                </div>
            </div>

        </section>
    );
}
 
export default OE;